export default __webpack_public_path__ + "static/media/loading.777d1bc4.png";